import { revenueQueryTypes } from '../../constants/revenue';
import { createFilterReducer } from '../filter';
import {
  dashboardRevenuePaymentFilterActions,
  dashboardRevenuePaymentFilterActionsPrefix,
} from '../../constants/filter';
import { chartAxes, dateColumns, paymentAmounts } from '../../constants/event';
import { sortingOptions, sortingOrder } from '../../constants/common';
import { getViews } from '../../containers/dashboards/cards/builder/revenue/revenueOptionsBarUtils';

const filterReducer = createFilterReducer(dashboardRevenuePaymentFilterActionsPrefix);

const columnChartSortingInitialState = {
  axis: chartAxes.Y,
  order: sortingOrder.DESCENDING,
  sortingOptions: sortingOptions.INDEPEND,
};

const composeInitialState = {
  queryType: revenueQueryTypes.REVENUE,
  groupColumn: dateColumns.DAY,
  splitColumn: undefined,
  amountFields: [],
  amountField: undefined,
  paymentFilter: filterReducer(undefined, {}),
  options: {
    columnChartSorting: columnChartSortingInitialState,
    views: [],
    view: 'Chart',
    singleChartMode: true,
    showFormula: false,
    calcTotal: false,
    averageLine: false,
    medianLine: false,
    trendLine: false,
    showSortingOptions: false,
    enteredFormula: null,
    adaptive: false,
    isExpand: false,
  },
};

const revenueCompose = (state = composeInitialState, action) => {
  switch (action.type) {
    case 'DASHBOARD_CHANGE_REVENUE_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
          showFormula: false,
        },
      };

    case 'DASHBOARD_TOGGLE_REVENUE_CALC_TOTAL':
      return {
        ...state,
        options: {
          ...state.options,
          calcTotal: !state.options.calcTotal,
        },
      };

    case 'DASHBOARD_TOGGLE_REVENUE_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'DASHBOARD_TOGGLE_REVENUE_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'DASHBOARD_TOGGLE_REVENUE_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'DASHBOARD_TOGGLE_REVENUE_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    case 'DASHBOARD_CHANGE_REVENUE_COLUMN_CHART_SORTING':
      return {
        ...state,
        options: {
          ...state.options,
          columnChartSorting: action.sorting,
        },
      };

    case 'DASHBOARD_REVENUE_SET_EXPAND':
      return {
        ...state,
        options: {
          ...state.options,
          isExpand: action.value,
        },
      };

    case 'SET_META_INFO_FOR_REVENUE': {
      const fields = action.paths
        ? paymentAmounts
            .map((p) => action.paths.find(({ path }) => `event.${p}` === path))
            .filter((e) => !!e)
        : [];

      return {
        ...state,
        amountFields: fields,
        amountField: fields[0],
      };
    }

    case 'DASHBOARD_SET_AMOUNT_FIELD':
      return {
        ...state,
        amountField: action.amountField,
      };

    case 'DASHBOARD_REVENUE_COMPOSE_SET_GROUP_COLUMN':
      return {
        ...state,
        groupColumn: action.groupColumn,
        options: {
          ...state.options,
          view: getViews(action.groupColumn)[0],
        },
      };

    case 'DASHBOARD_REVENUE_COMPOSE_SET_SPLIT_COLUMN':
      return {
        ...state,
        splitColumn: action.splitColumn,
      };

    case 'DASHBOARD_CHANGE_REVENUE_QUERY_TYPE': {
      let { groupColumn, splitColumn } = state;
      let { view } = state.options;
      const payersAndARPU = [revenueQueryTypes.ARPU, revenueQueryTypes.PAYERS];

      const isResetOptions = !(
        (payersAndARPU.includes(action.queryType) && payersAndARPU.includes(state.queryType)) ||
        (!payersAndARPU.includes(action.queryType) && !payersAndARPU.includes(state.queryType))
      );

      if (isResetOptions) {
        groupColumn = dateColumns.DAY;
        splitColumn = undefined;

        const [firstView] = getViews(groupColumn);

        view = firstView;
      }

      return {
        ...state,
        queryType: action.queryType,
        groupColumn,
        splitColumn,
        options: {
          ...state.options,
          view,
        },
      };
    }

    case dashboardRevenuePaymentFilterActions.ADD_FILTER_CLAUSE:
    case dashboardRevenuePaymentFilterActions.REMOVE_FILTER:
    case dashboardRevenuePaymentFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardRevenuePaymentFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case dashboardRevenuePaymentFilterActions.SET_FILTER_VISIBILITY:
      return {
        ...state,
        paymentFilter: filterReducer(state.paymentFilter, action),
      };

    default:
      return state;
  }
};

export default revenueCompose;

export const getAmountField = (state) => state.amountField;

export const getAmountFields = (state) => state.amountFields;

export const getGroupColumn = (state) => state.groupColumn;

export const getSplitColumn = (state) => state.splitColumn;

export const getQueryType = (state) => state.queryType;

export const getPaymentFilter = (state) => state.paymentFilter;

export const getOptions = (state) => state.options;
